import { useEffect } from 'react';
import { useMantineColorScheme } from '@mantine/core';

const LIGHT_MEDIA = '(prefers-color-scheme: light)';

// Mirrors of Mantine --mantine-color-body in each scheme — match index.html's
// initial <meta name="theme-color"> values so first paint and runtime updates agree.
const THEME_COLOR_DARK = '#242424';
const THEME_COLOR_LIGHT = '#ffffff';

// Iterates over the no-media fallback tag and both media-query'd tags because
// iOS Safari does not always honor media-query'd theme-color in regular
// browser mode — the no-media fallback is the deterministic source.
export function useThemeColor(): void {
  const { colorScheme } = useMantineColorScheme();

  useEffect(() => {
    const allMetas = document.querySelectorAll<HTMLMetaElement>(
      'meta[name="theme-color"]'
    );
    if (allMetas.length === 0) return;

    if (colorScheme === 'auto') {
      allMetas.forEach((meta) => {
        meta.content =
          meta.getAttribute('media') === LIGHT_MEDIA
            ? THEME_COLOR_LIGHT
            : THEME_COLOR_DARK;
      });
      return;
    }

    const explicitColor =
      colorScheme === 'dark' ? THEME_COLOR_DARK : THEME_COLOR_LIGHT;
    allMetas.forEach((meta) => {
      meta.content = explicitColor;
    });
  }, [colorScheme]);
}
